export const removeFromLocalStorage = (key:string):void => {
  localStorage.removeItem(key)
}